import { useMemo } from "react";
import { invokeCopilotAction, useCopilotAction } from "./actionRegistry";

const VIEW_ARCHIVED_ENCOUNTERS_DESCRIPTOR = Object.freeze({
  name: "view_archived_encounters",
  description: "Implemented by noki-fe (navigate to Archived Encounters page).",
  classification: "READ",
  parameters: [],
});

export function useCopilotViewArchivedEncountersAction() {
  const descriptor = useMemo(() => VIEW_ARCHIVED_ENCOUNTERS_DESCRIPTOR, []);

  useCopilotAction(descriptor, async () => {
    // eslint-disable-next-line no-console
    console.info("[copilot] view_archived_encounters.invoke");

    const result = await invokeCopilotAction("navigate", {
      to: "/settings/archived_encounters",
    });

    if (result?.status !== "ok") {
      throw new Error(
        result?.errorMessage || "Failed to navigate to archived encounters.",
      );
    }

    return {
      route: "/settings/archived_encounters",
      navigated: true,
      ...(result?.data ? { navigateResult: result.data } : {}),
    };
  });
}
